
export const leagueId = "01H42KPJB1GG8EKMEJC50KM6PW";
export const apiKey = "2ff73ab3016540b097d3c5cfed50f001f3fb1ce8cf144cc7a9282ee530bb5f2f";
export const baseUrl = "https://formularacinggroup.au/api";